import api from '@/api'

export default {
  setTranslation({ commit, state }, data) {
    commit('SET_TRANSLATION', data)
  },
  setServiceElementTranslation({ commit, state }, data) {
    commit('SET_SERVICE_ELEMENT_TRANSLATION', data)
  },
  setCustomMessageTranslation({ commit, state }, data) {
    commit('SET_CUSTOM_MESSAGE_TRANSLATION', data)
  },
  async translateAllReportSections({ commit, state }, code) {
    state.translations = []
    return new Promise((resolve, reject) => {
      api.translateAllReportSections(code)
        .then(response => {
          commit('SET_TRANSLATIONS', response.data)
          resolve(response)
        })
    })
  },
  async getReportTranslations({ commit, state }, data) {
    state.translations = []
    return new Promise((resolve, reject) => {
      api.getReportTranslations(data)
        .then(response => {
          commit('SET_TRANSLATIONS', response.data)
          resolve(response)
        })
    })
  },
  async saveTranslations({ commit }, data) {
    return new Promise((resolve, reject) => {
      api.saveTranslations(data)
        .then(response => {
          resolve(response)
        })
    })
  },
  async translateAllServiceElements({ commit, state }, cultureCode) {
    state.serviceElementTranslations = []
    return new Promise((resolve, reject) => {
      api.translateAllServiceElements(cultureCode)
        .then(response => {
          commit('SET_SERVICE_ELEMENT_TRANSLATIONS', response.data)
          resolve(response)
        })
    })
  },
  async getServiceElementTranslations({ commit, state }, data) {
    state.serviceElementTranslations = []
    return new Promise((resolve, reject) => {
      api.getServiceElementTranslations(data)
        .then(response => {
          commit('SET_SERVICE_ELEMENT_TRANSLATIONS', response.data)
          resolve(response)
        })
    })
  },
  async saveServiceElementTranslations({ commit }, data) {
    return new Promise((resolve, reject) => {
      api.saveServiceElementTranslations(data)
        .then(response => {
          resolve(response)
        })
    })
  },
  async localeTranslation({ commit }, data) {
    return new Promise((resolve, reject) => {
      api.localeTranslation(data)
        .then(response => {
          resolve(response)
        })
    })
  },
  async getRagCustomMessageTranslations({ commit, state }, cultureCode) {
    state.customMessageTranslations = []
    return new Promise((resolve, reject) => {
      api.getRagCustomMessageTranslations(cultureCode)
        .then(response => {
          // Parse the JSON response from the API
          const translations = typeof response.data === 'string'
            ? JSON.parse(response.data)
            : response.data
          commit('SET_CUSTOM_MESSAGE_TRANSLATIONS', translations)
          resolve(response)
        })
        .catch(error => {
          console.error('Vuex: API error:', error)
          reject(error)
        })
    })
  },
  async processCustomMessageTranslations({ commit }, data) {
    return new Promise((resolve, reject) => {
      api.processCustomMessageTranslations(data)
        .then(response => {
          resolve(response)
        })
        .catch(reject)
    })
  },
  async deleteCustomMessageTranslations({ commit }, translationIds) {
    return new Promise((resolve, reject) => {
      api.deleteCustomMessageTranslations(translationIds)
        .then(response => {
          resolve(response)
        })
        .catch(reject)
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/translation/actions.js